import { render } from "./ContactPerson.vue?vue&type=template&id=b4e6efcc&scoped=true"
import script from "./ContactPerson.vue?vue&type=script&lang=js"
export * from "./ContactPerson.vue?vue&type=script&lang=js"

import "./ContactPerson.vue?vue&type=style&index=0&id=b4e6efcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e6efcc"]])

export default __exports__